import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import queryString from 'query-string'
import avatar from '../assets/avatar.jpg'
import { AboutText } from './AboutText'
class About extends React.Component {
        constructor() {
            super();
            this.text = ""
            this.r = ""
        }
        componentDidMount() {

            fetch('/../constants/about.txt')
                .then((r) => { console.log(r); r.text() })
                .then(text => {
                    this.text = text;
                })
        }
        render() {
            // const search =queryString.parse(this.props.location.search).track
            return (
                <div style={{ display: 'flex', flex: 1, width: "100vw" }}>
                    <div ref={this.scrollthis} className="List">
                        <ReactCSSTransitionGroup
                            transitionName="example"
                            transitionAppear={true}
                            transitionAppearTimeout={800}
                            transitionEnterTimeout={500}
                            transitionLeaveTimeout={300}>

                            <AboutText />
                        </ReactCSSTransitionGroup>;
                </div>
                </div>
            );
        }
    }
export default About


// WEBPACK FOOTER //
// ./src/components/About.js